import categoriesApiServices from '../../api/categories';
import jobsApiServices from '../../api/jobs';

export default {
  getJobs: async ({ state, commit }, { jobsFilters, force = true }) => {
    const { page } = jobsFilters;
    const key = `page=${page}`;
    const cachedJobs = state.cachedJobs[key];

    if (!force && cachedJobs && cachedJobs.length > 0) {
      commit('SET_JOBS', cachedJobs);
      commit('SET_JOBS_LOADING', false);
      return cachedJobs;
    }

    try {
      commit('SET_JOBS_LOADING', true);
      const { data } = await jobsApiServices.getAll(jobsFilters);
      commit('SET_JOBS_LOADING', false);
      if (!data) return [];
      const jobs = data;
      commit('SET_JOBS', jobs);
      commit('CACHE_JOBS', { key, jobs });
      return jobs;
    } catch (error) {
      commit('SET_JOBS_LOADING', false);
      return []
    } finally {
      commit('SET_JOBS_LOADING', false);
    }
  },
  getCategories: async ({ state, commit }, { filters, force = true }) => {
    const { page = 0 } = filters;
    const key = `page=${page}`;
    const cachedCategories = state.cachedCategories[key];

    if (!force && cachedCategories) {
      commit('SET_CATEGORIES', cachedCategories);
      return cachedCategories;
    }

    const { data } = await categoriesApiServices.getAll();
    if (!data) return [];
    const { categories } = data;
    commit('SET_CATEGORIES', categories);
    commit('CACHE_CATEGORIES', { key, categories });

    return categories;
  },
  getJobsById: async ({ state, commit }, { jobId, force = true }) => {
    const key = `job${jobId}`;
    const cachedJobId = state.cachedJobId[key];

    if (!force && cachedJobId) {
      commit('SET_JOBID', cachedJobId);
      commit('SET_JOB_LOADING', false);
      return cachedJobId;
    }
    try {
      commit('SET_JOB_LOADING', true);
      const { data } = await jobsApiServices.getById({ jobId, includeCategory: true });
      if (!data) return [];
      commit('SET_JOBID', data);
      commit('CACHE_JOBID', { key, data });

      return data;
    } catch (error) {
      return []
    } finally {
      commit('SET_JOB_LOADING', false);
    }
  },
  getJobsByCompanyId: async (
    { state, commit },
    { includeIndications = true, companyEmail = '', force = false },
  ) => {
    const key = `job_companyId=${new Date().getTime()}`;
    const cachedJobCompanyId = state.cachedJobCompanyId[key];

    if (!force && cachedJobCompanyId) {
      commit('SET_JOB_COMPANY_ID', cachedJobCompanyId);
      return cachedJobCompanyId;
    }

    const { data } = await jobsApiServices.getByCompanyId({ includeIndications, companyEmail });
    if (!data) return [];
    const { jobs } = data
    commit('SET_JOB_COMPANY_ID', jobs);
    commit('CACHE_JOB_COMPANY_ID', { key, data: jobs });

    return data;
  },
  setFilterJobs: ({ state, commit }, filter) => {
    const { jobsFilters } = state;
    Object.keys(filter).forEach((key) => {
      const valor = filter[key];
      jobsFilters[key] = valor;
    });

    commit('JOBS_FILTERS', jobsFilters);
  },
};
